import { Button, Col, Form, Input, Row } from "antd";
import ContaViagemTable from "./ContaViagemTable";
import DrawerBasic, { IDrawerBasicRef } from "@/Components/Base/Drawer/DrawerBasic";
import ContaViagemForm from "./ContaViagemForm";
import { useRef, useEffect, useState } from "react";
import { ContaViagemListarFiltros, useContaViagemListar } from "@/Services/Domain/Viagem/Financeiro/ContaViagemService";
import { CentroCustoSelectItem } from "@/Components/Populados/Financeiro/CentroConta/CentroCustoSelect";
import { EnumCentroCustoTipo } from "@/Models/Financeiro/CentroCustoTipo";
import ViagemSelect from "../../ViagemSelect";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import ContaViagemSituacaoSelect from "./Situacao/ContaViagemSituacaoSelect";

export type ContaViagemConsultaScreenFiltros = ContaViagemListarFiltros & {

}
export interface IContaViagemConsultaScreenProps {

}
export default function ContaViagemConsultaScreen({

}:IContaViagemConsultaScreenProps) {
    const [form] = Form.useForm<ContaViagemConsultaScreenFiltros>();
    const refNova = useRef<IDrawerBasicRef>(null);

    const filtros = Form.useWatch([], form);

    const {
        data,
        refetch,
        isLoading,
        isFetching
    } = useContaViagemListar({
        ativo : true,
        contaViagem : filtros?.contaViagem,
        paginaInfo : filtros?.paginaInfo,
        enabled : false && !!filtros?.paginaInfo
    });

    useEffect(() => {
        refetch();
    }, [filtros?.paginaInfo]);

    return <div>
        <Form
            form={form}
            layout={"vertical"}
            autoComplete={"off"}
            size="small"
            initialValues={{
                paginaInfo: new PaginaInfo()
            }}
            onFinish={() => {
                refetch();
            }}
            style={{
                marginBottom : 4
            }}
        >
            <Row gutter={4} wrap justify="start" align="bottom">
                <Form.Item<ContaViagemConsultaScreenFiltros> name={["paginaInfo"]} hidden label="Pagina Info">
                    <Input hidden />
                </Form.Item>
                <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                    <Form.Item<ContaViagemConsultaScreenFiltros> name={["contaViagem", "conta", "nome"]} label="Nome">
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                    <Form.Item<ContaViagemConsultaScreenFiltros> name={["contaViagem", "codCentroCusto"]} label="Centro de custos">
                        <CentroCustoSelectItem
                            filtros={{
                                tipo : {
                                    codigo : EnumCentroCustoTipo.ITEM
                                },
                                ativo : true
                            }}  
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                    <Form.Item<ContaViagemConsultaScreenFiltros> name={["contaViagem", "codViagem"]} label="Viagem">
                        <ViagemSelect />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                    <Form.Item<ContaViagemConsultaScreenFiltros> name={["contaViagem", "codSituacao"]} label="Viagem">
                        <ContaViagemSituacaoSelect />
                    </Form.Item>
                </Col>
                <ComponentePermissao permissoes={["DomainViagemFinanceiroContaViagemListar"]}>
                    <Col xs={"auto"}>
                        <Form.Item<ContaViagemConsultaScreenFiltros>>
                            <Button type="primary" htmlType="submit">Listar</Button>
                        </Form.Item>
                    </Col>
                </ComponentePermissao>
                <ComponentePermissao permissoes={["DomainViagemFinanceiroContaViagemInserir"]}>
                    <Col xs={"auto"}>
                        <Form.Item<ContaViagemConsultaScreenFiltros>>
                            <DrawerBasic
                                ref={refNova}
                                elementoGatilho={<Button type="dashed">Adicionar</Button>}
                                destroyOnClose={true}
                            >
                                <ContaViagemForm 
                                    onCancelar={(e) => {
                                        refNova.current?.fechar(e);
                                    }}
                                    onSuccess={() => {
                                        refNova.current?.fechar({} as any);
                                        refetch();
                                    }}
                                />
                            </DrawerBasic>
                        </Form.Item>
                    </Col>
                </ComponentePermissao>
            </Row>
        </Form>

        <ContaViagemTable 
            dataSource={data}
            loading={isLoading || isFetching}
            onSuccess={(acao) => {
                if (acao === "alterarSituacao" || acao === 'editar') refetch();
            }}
            onChange={(pagina, ...restParam) => {
                form.setFieldsValue({
                    paginaInfo : {
                        pagina : pagina.current ?? 1,
                        tamanho : pagina.pageSize ?? 20
                    }
                } as any);
            }} 
        />
    </div>
}